import React, { useState, useEffect } from "react";
import "./Magazine.css";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { FaEye } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { MdArrowBackIosNew } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import Loading from "../../../Components/Loading/Loading";
import { useBaseUrl } from "../../../ApiContext";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Magazine() {
  const location = useLocation();
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const { magazineId } = location.state || {};
  const [magazineData, setMagazineData] = useState(null);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showFullMagazine, setShowFullMagazine] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMahazineData = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/journals/${magazineId}`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        setMagazineData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting journals data", error);
      }
    };
    if (userToken) {
      fetchMahazineData();
    }
  }, [baseUrl, userToken]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const openFullMagazineHandler = () => {
    setShowFullMagazine((prevState) => !prevState);
  };

  const handleNextOrPrevMagazine = async (id) => {
    try {
      const response = await Axios.get(`${baseUrl}/journals/${id}`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setMagazineData(response.data);
    } catch (error) {
      console.log("Error during getting journals data", error);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="magazineContainer scroll responsiveWidth centeredFlex">
              <div className="magazineContainerTop centeredFlex">
                <div className="magazineBanner">
                  <LazyLoadImage
                    width="100%"
                    height="100%"
                    src={magazineData.cover || "/images/bgLogo.svg"}
                    alt="magazine banner"
                    effect="opacity"
                    placeholderSrc="/images/bgLogo.svg"
                    style={{
                      backgroundRepeat: "no-repeat",
                      borderRadius: "0.625",
                    }}
                    onError={({ target }) => {
                      target.onerror = null;
                      target.src = "/images/bgLogo.svg";
                    }}
                  />
                </div>
                <div className="magazineDateAndView centeredFlex">
                  <div className="magazineDate">
                    <FaCalendarAlt className="magazineDateAndTimeIcon" />
                    <span>{magazineData.created_at}</span>
                  </div>
                  <div className="magazineView">
                    <FaEye className="magazineDateAndTimeIcon" />
                    <span>{magazineData.view} بازدید</span>
                  </div>
                </div>
                <div className="magazineTitle centeredFlex">
                  <p>{magazineData.title}</p>
                  {magazineData.keyword.length > 0 && (
                    <div className="magazineCategory centeredFlex">
                      <span>{magazineData.keyword[0].word}</span>
                    </div>
                  )}
                </div>

                <div
                  className={`magazineContent ${
                    !showFullMagazine && "ellipsis"
                  }`}
                >
                  {magazineData.detail}
                </div>
                <button
                  className="magazineReadMoreBtn centeredFlex"
                  onClick={openFullMagazineHandler}
                >
                  {showFullMagazine ? "بستن" : "بیشتر بخوانید"}{" "}
                  <MdOutlineKeyboardArrowDown className="magazineArrowDrop" />
                </button>
              </div>
              <div
                className="nextAndPrevMagazines centeredFlex"
                style={
                  magazineData.previous !== null && magazineData.next !== null
                    ? { justifyContent: "space-between" }
                    : magazineData.previous !== null &&
                      magazineData.next === null
                    ? { justifyContent: "flex-end" }
                    : magazineData.previous === null &&
                      magazineData.next !== null
                    ? { justifyContent: "flex-start" }
                    : {}
                }
              >
                {magazineData.next !== null && (
                  <div
                    className="nextOrPrevMagazine centeredFlex"
                    style={{ alignItems: "flex-start" }}
                    onClick={() =>
                      handleNextOrPrevMagazine(magazineData.next.id)
                    }
                  >
                    <div className="nextOrPrevMagazineTop centeredFlex">
                      <MdArrowForwardIos
                        className="nextOrPrevMagazineIcon"
                        style={{ marginLeft: "0.625rem" }}
                      />
                      مطلب بعدی
                    </div>
                    <div className="nextOrPrevMagazineBottom">
                      <div
                        className="nextOrPrevMagazineCover"
                        style={{ borderRadius: "0 0.625rem 0.625rem 0" }}
                      >
                        <LazyLoadImage
                          width="100%"
                          height="100%"
                          src={magazineData.next.cover || "/images/bgLogo.svg"}
                          alt="next magazine cover"
                          effect="opacity"
                          placeholderSrc="/images/bgLogo.svg"
                          style={{
                            backgroundRepeat: "no-repeat",
                            borderRadius: "0 0.625rem 0.625rem 0",
                          }}
                          onError={({ target }) => {
                            target.onerror = null;
                            target.src = "/images/bgLogo.svg";
                          }}
                        />
                      </div>
                      <div className="nextOrPrevMagazineContent centeredFlex">
                        <span className="nextOrPrevMagazineTitle">
                          {magazineData.next.title}
                        </span>
                        <span className="nextOrPrevMagazineCategory">
                          {magazineData.next.keyword.length > 0 &&
                            magazineData.next.keyword[0].word}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {magazineData.previous !== null && (
                  <div
                    className="nextOrPrevMagazine centeredFlex"
                    style={{ alignItems: "flex-end" }}
                    onClick={() =>
                      handleNextOrPrevMagazine(magazineData.previous.id)
                    }
                  >
                    <div
                      className="nextOrPrevMagazineTop centeredFlex"
                      style={{ justifyContent: "flex-end" }}
                    >
                      مطلب قبلی
                      <MdArrowBackIosNew
                        className="nextOrPrevMagazineIcon"
                        style={{ marginRight: "0.625rem" }}
                      />
                    </div>
                    <div className="nextOrPrevMagazineBottom centeredFlex">
                      <div className="nextOrPrevMagazineContent centeredFlex">
                        <span className="nextOrPrevMagazineTitle">
                          {magazineData.previous.title}
                        </span>
                        <span className="nextOrPrevMagazineCategory">
                          {magazineData.previous.keyword[0].word}
                        </span>
                      </div>
                      <div
                        className="nextOrPrevMagazineCover"
                        style={{ borderRadius: "0.625rem 0 0 0.625rem" }}
                      >
                        <LazyLoadImage
                          width="100%"
                          height="100%"
                          src={
                            magazineData.previous.cover || "/images/bgLogo.svg"
                          }
                          alt="next magazine cover"
                          effect="opacity"
                          placeholderSrc="/images/bgLogo.svg"
                          style={{
                            backgroundRepeat: "no-repeat",
                            borderRadius: "0.625rem 0 0 0.625rem",
                          }}
                          onError={({ target }) => {
                            target.onerror = null;
                            target.src = "/images/bgLogo.svg";
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
